<lex-doc-viewer-dialog>
    <div dialog-title>{{title}}</div>
    <div dialog-body style="max-height: 55vh; overflow: auto; margin-bottom: 10px;">
        <div style="padding: 10px 16px; margin: 12px; font-size: 13px;">{{message}} </div>
    </div>
    <div dialog-actions >
        <div style="display:flex; flex-direction: row; justify-content: flex-end; padding: 12px; gap: 4px;">
            <lex-flat-button (click)="ok()" [type]="'action'" label="Ok"></lex-flat-button>
            <lex-flat-button [type]="'action'" label="Cancel" matDialogClose></lex-flat-button>
          </div>
    </div>
  </lex-doc-viewer-dialog>
  